import React from "react";
import { Routes, Route } from "react-router";
import WealthManagerLogin from "../pages/WealthManagerLogin.jsx";
import InvestorLogin from "../pages/InvestorLogin.jsx";
import WealthManagerDashboard from "../pages/WealthManagerDashboard.jsx";
import InvestorDashboard from "../pages/InvestorDashboard.jsx";
import WMPasswordReset from "../pages/WMResetPassword.jsx";
import InvestorResetPassword from "../pages/InvestorResetPassword.jsx";
import WMDemoDashboard from "../pages/WMDemoDashboard.jsx";
import Home from "../pages/Home.jsx";
import WMDemoDashboardInvdiv from "../pages/WMDemoDashboardIndiv.jsx";

const AllRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wealth-manager-login" element={<WealthManagerLogin />} />
        <Route path="/investor-login" element={<InvestorLogin />} />
        <Route
          path="/wealth-manager-dashboard"
          element={<WealthManagerDashboard />}
        />
        {/* <Route path='/new-wealth-manager-dashboard' element={<DashboardWM/>}/> */}
        <Route path="/wmdemo/:email" element={<WMDemoDashboard />} />
        <Route
          path="/wmdemoind/:email/:indivemail"
          element={<WMDemoDashboardInvdiv />}
        />
        <Route path="/investor-dashboard" element={<InvestorDashboard />} />
        <Route path="/wmpassword-reset" element={<WMPasswordReset />} />
        <Route
          path="/investor-password-reset"
          element={<InvestorResetPassword />}
        />
      </Routes>
    </div>
  );
};

export default AllRoutes;
